export default __webpack_public_path__ + "static/media/mail.df610299.svg";